export default "__VITE_ASSET__Dev_6VTV__"